import { IStateConfiguration } from './../../global/types';
import { ICommand } from 'core-ts-types';

export class ResourcesRouteConfiguration {
  constructor(private $stateProvider: ng.ui.IStateProvider) {}

  state(stateConfiguration: IStateConfiguration) {
    this.$stateProvider.state(
      'my.resources',
      _.merge(
        {
          sticky: true,
          url: 'resources/',
          resolve: {
            _campusResourceCategories: (loadResourceCategoriesCommand: ICommand, _accessToken: ng.IPromise<never>) => {
              return loadResourceCategoriesCommand();
            },
            _campusResources: (loadResourcesCommand: ICommand, _accessToken: ng.IPromise<never>) => {
              return loadResourcesCommand();
            }
          },
          views: {
            'my@my': {
              templateUrl: 'lib/resources/views/resource_categories/resource_categories.html',
              controller: 'ngResourceCategoriesController',
              controllerAs: '$ctrl'
            }
          }
        },
        _.get(stateConfiguration, 'my.resources'),
        (a, b) => _.merge(a, b)
      )
    );
  }

  $get() {
    return {};
  }
}

angular.module('capability-ng-resources').provider('ngResourcesRouteConfiguration', ResourcesRouteConfiguration);



// WEBPACK FOOTER //
// ./app/lib/resources/config/route_configuration.ts